import ProcessedBooking from "../../stores/domainStore/pages/models/processedBooking";
import {SortOrder} from "../../shared/enums/sortOrder";
import {compareDates, compareStrings} from "./sortUtil";
import ProcessedBookingGroup from "../../stores/domainStore/pages/models/processedBookingGroup";

export class ProcessedBookingsCSVSortUtil {
  transactions: ProcessedBooking[];

  constructor(transactions: ProcessedBookingGroup[]) {
    this.transactions = this.flattenTransactions(transactions);
  }

  sortForCSV(): ProcessedBooking[] {
    return this.transactions.sort(
      (a: ProcessedBooking, b: ProcessedBooking) => {
        const diffEventDate = compareDates(
          a.timestamp,
          b.timestamp,
          SortOrder.Descending
        );

        if (diffEventDate === 0) {
          const diffChargedDates = compareDates(
            a.createdDate,
            b.createdDate,
            SortOrder.Ascending
          );
          // Secondary sort on payee
          return diffChargedDates === 0
            ? compareStrings(a.payeeName, b.payeeName, SortOrder.Ascending)
            : diffChargedDates;
        }
        return diffEventDate;
      }
    );
  }

  private flattenTransactions(
    events: ProcessedBookingGroup[]
  ): ProcessedBooking[] {
    return events.flatMap((event) => event.processedBookings);
  }
}
